import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Button from '../button/Button';
import { useUserAgent } from 'src/common/userAgent/useUserAgent';
import useWfSecurityService from 'src/api/wf/service/WfSecurityService';
import { wfNavigate } from '../../router/WfScreenRegistration';
import { WfScreensMap } from '../../router/WfScreensMap';
import { WF_Screen } from '../../router/WfScreens';
import clsx from 'clsx';

const URL_JMA = 'https://www.jma.go.jp/jma/index.html';

function WfHeader() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const userAgent = useUserAgent();
  const { wfLogoutUser } = useWfSecurityService();

  const menuActionHandler = useCallback(() => {
    if (userAgent.isDesktop) {
      console.log('should reset view');
    } else {
      wfNavigate(navigate, WfScreensMap[WF_Screen.MainMenu].path);
    }
  }, [userAgent.isDesktop, navigate]);

  return (
    <header
      className={clsx(
        'flex items-center justify-between border-b border-blue-600',
        userAgent.isDesktop ? 'px-3' : 'px-2'
      )}
    >
      <div className="flex flex-1 flex-col">
        <h1 className="text-xl">{t('wf.common.title')}</h1>
        <div className="flex flex-row justify-between">
          <a className="text-blue-400" href={URL_JMA} target="_blank" rel="noopener noreferrer">
            {t('wf.header.jma')}
          </a>
        </div>
      </div>

      <div
        className={`flex items-center ${
          userAgent.isDesktop ? 'flex-row space-x-3 py-4' : 'flex-col space-y-2 py-2'
        }`}
      >
        <Button
          title={t('wf.header.logout')}
          onClick={wfLogoutUser}
          className={!userAgent.isDesktop ? 'w-full text-xs' : ''}
        />
        {userAgent.isMobile && (
          <Button
            title={t('wf.header.mainMenu')}
            onClick={menuActionHandler}
            className="w-full text-xs"
          />
        )}
      </div>
    </header>
  );
}

export default WfHeader;
